module.exports = __webpack_public_path__ + "static/media/logo.ac1ae0bc.svg";